import React, { useState } from 'react';
import { Building2, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="navbar bg-background border-b border-border sticky top-0 z-50 backdrop-blur-sm bg-background/95">
      <div className="navbarContainer max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 logo" aria-label="FraxLandShare home">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center">
              <Building2 className="w-6 h-6 text-white" />
            </div>
            <span className="text-xl font-bold text-foreground">FraxLandShare</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8 navLinks">
            <a href="#how-it-works" className="navLink" onClick={(e) => { e.preventDefault(); document.querySelector('#how-it-works')?.scrollIntoView({ behavior: 'smooth' }); }}>How it Works</a>
            <Link to="/about" className="navLink">About</Link>
            <Link to="/investment-guide" className="navLink">Investor Guide</Link>
            <Link to="/contact" className="navLink">Contact</Link>
          </div>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/login" className="navLink">Login</Link>
            <Link to="/contact" className="navLink btn-hero">Request an invite</Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden navToggle" onClick={toggleMenu} aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen}>
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden bg-background border-t border-border">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="#how-it-works" className="block px-3 py-2 navLink" onClick={(e) => { e.preventDefault(); document.querySelector('#how-it-works')?.scrollIntoView({ behavior: 'smooth' }); toggleMenu(); }}>How it Works</a>
              <Link to="/about" className="block px-3 py-2 navLink" onClick={toggleMenu}>About</Link>
              <Link to="/investment-guide" className="block px-3 py-2 navLink" onClick={toggleMenu}>Investor Guide</Link>
              <Link to="/contact" className="block px-3 py-2 navLink" onClick={toggleMenu}>Contact</Link>
              <div className="border-t border-border mt-4 pt-4">
                <Link to="/login" className="block px-3 py-2 navLink" onClick={toggleMenu}>Login</Link>
                <Link to="/contact" className="block px-3 py-2 btn-hero text-center" onClick={toggleMenu}>Request an invite</Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
